import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { isNull } from "lodash"
import { addIndex, curry, find, map, pipe, prop, sortBy } from "ramda"

export const recursion =
    (f: (...args: Array<any>) => any) =>
    (...args: Array<any>) =>
        f((...argsi: Array<any>) => recursion(f)(...argsi), ...args)

export const findAndReturn = (callback: (item: any) => any, collection: Array<any>) => {
    for (let i = 0; i < collection.length; i++) {
        const value = callback(collection[i])

        if (!isNull(value)) {
            return value
        }
    }

    return null
}

export const pipeline = (
    argument: any,
    ...inputs: Array<any> // @ts-expect-error
) => pipe(...inputs)(argument)

export const mapIndexed = curry(addIndex(map))

export const findById = <
    T extends {
        id: string
    },
>(
    id: Maybe<string>,
    data: T[]
): Maybe<T> => find(o => o.id === id, data)

export const sortBySortIndex = sortBy(prop("sort_index"))

export const cycleElements = <T>(element: T, elements: T[]): T => {
    const idx = elements.findIndex(e => e === element)
    return idx === -1 ? elements[0] : elements[(idx + 1) % elements.length]
}
